/* plant.icon.svg.js */

module.exports = {
    icon: `<svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="foreground-gl" fill-rule="evenodd" clip-rule="evenodd" d="M21.276 0.568359L19.6646 16.8507H17.7808V12.8758L12.1094 16.8507V12.8758L6.43799 16.8507V12.8758L0.766602 16.8507V29.84H15.9513V22.1562H21.0738V29.84H27.8429V16.8507H25.4128L23.8758 0.568359H21.276ZM2.96198 25.6322V22.1562H6.25504V25.6322H2.96198ZM8.99926 22.1562V25.6322H12.2923V22.1562H8.99926Z" fill="#5D6F80"/>
  </svg>  
    `
};
